import {
    CORE_LOAD_EVENTINCOMING_REQUEST,
    CORE_LOAD_EVENTINCOMING_SUCCESS,
    CORE_LOAD_EVENTINCOMING_FAILURE,

    CORE_LOAD_ROOMINFO_REQUEST,
    CORE_LOAD_ROOMINFO_SUCCESS,
    CORE_LOAD_ROOMINFO_FAILURE,

    CORE_LOAD_SLOTS_REQUEST,
    CORE_LOAD_SLOTS_SUCCESS,
    CORE_LOAD_SLOTS_FAILURE,

    CORE_LOAD_ORDERS_REQUEST,
    CORE_LOAD_ORDERS_SUCCESS,
    CORE_LOAD_ORDERS_FAILURE,

    CORE_LOAD_EVENTHISTORY_REQUEST,
    CORE_LOAD_EVENTHISTORY_SUCCESS,
    CORE_LOAD_EVENTHISTORY_FAILURE,

    CORE_LOAD_FLOORS_REQUEST,
    CORE_LOAD_FLOORS_SUCCESS,
    CORE_LOAD_FLOORS_FAILURE,

    CORE_CREATE_EVENT_REQUEST,
    CORE_CREATE_EVENT_SUCCESS,
    CORE_CREATE_EVENT_FAILURE,

    CORE_LOAD_AMENITIES_REQUEST,
    CORE_LOAD_AMENITIES_SUCCESS,
    CORE_LOAD_AMENITIES_FAILURE,

    // CORE_LOAD_AMENITYACTIVE_REQUEST,
    // CORE_LOAD_AMENITYACTIVE_SUCCESS,
    // CORE_LOAD_AMENITYACTIVE_FAILURE,

    // CORE_LOAD_AMENITYPAST_REQUEST,
    // CORE_LOAD_AMENITYPAST_SUCCESS,
    // CORE_LOAD_AMENITYPAST_FAILURE,

    BSRS_LOGIN_REQUEST,
    BSRS_LOGIN_SUCCESS,
    BSRS_LOGIN_FAILURE,

    // O365_LOAD_PEOPLE_REQUEST,
    // O365_LOAD_PEOPLE_SUCCESS,
    // O365_LOAD_PEOPLE_FAILURE,

    CORE_LOAD_EVENTINFO_REQUEST,
    CORE_LOAD_EVENTINFO_SUCCESS,
    CORE_LOAD_EVENTINFO_FAILURE,

    CORE_EDIT_EVENT_REQUEST,
    CORE_EDIT_EVENT_SUCCESS,
    CORE_EDIT_EVENT_FAILURE,

    CORE_DELETE_EVENT_REQUEST,
    CORE_DELETE_EVENT_SUCCESS,
    CORE_DELETE_EVENT_FAILURE,

    CORE_CHECKIN_REQUEST,
    CORE_CHECKIN_SUCCESS,
    CORE_CHECKIN_FAILURE,

    CORE_LOAD_FLOOR_INFO_REQUEST,
    CORE_LOAD_FLOOR_INFO_SUCCESS,
    CORE_LOAD_FLOOR_INFO_FAILURE,

    CORE_LOAD_EVENTCALENDAR_REQUEST,
    CORE_LOAD_EVENTCALENDAR_SUCCESS,
    CORE_LOAD_EVENTCALENDAR_FAILURE,

    CORE_SEARCH_ROOMS_REQUEST,
    CORE_SEARCH_ROOMS_SUCCESS,
    CORE_SEARCH_ROOMS_FAILURE,

    CORE_LOAD_ROOMS_SUGGEST_REQUEST,
    CORE_LOAD_ROOMS_SUGGEST_SUCCESS,
    CORE_LOAD_ROOMS_SUGGEST_FAILURE,

    CORE_VERIFY_BYPASS_REQUEST,
    CORE_VERIFY_BYPASS_SUCCESS,
    CORE_VERIFY_BYPASS_FAILURE,

    CORE_LOAD_ROOM_FORMAT_REQUEST,
    CORE_LOAD_ROOM_FORMAT_SUCCESS,
    CORE_LOAD_ROOM_FORMAT_FAILURE,

    LOAD_ROOMINFO_REQUEST,
    LOAD_ROOMINFO_SUCCESS,
    LOAD_ROOMINFO_FAILURE,

    CORE_LOAD_SETTINGS_REQUEST,
    CORE_LOAD_SETTINGS_SUCCESS,
    CORE_LOAD_SETTINGS_FAILURE,

    CORE_SEND_EMAIL_REQ_RESET_PASSWORD_REQUEST,
    CORE_SEND_EMAIL_REQ_RESET_PASSWORD_SUCCESS,
    CORE_SEND_EMAIL_REQ_RESET_PASSWORD_FAILURE,

    CORE_CHANGE_PASSWORD_REQUEST,
    CORE_CHANGE_PASSWORD_SUCCESS,
    CORE_CHANGE_PASSWORD_FAILURE,

    CORE_FIRST_CHANGE_PASSWORD_REQUEST,
    CORE_FIRST_CHANGE_PASSWORD_SUCCESS,
    CORE_FIRST_CHANGE_PASSWORD_FAILURE,

    CORE_SEND_REPORT_REQUEST,
    CORE_SEND_REPORT_SUCCESS,
    CORE_SEND_REPORT_FAILURE,

    CORE_VERIFY_LOGIN_REQUEST,
    CORE_VERIFY_LOGIN_SUCCESS,
    CORE_VERIFY_LOGIN_FAILURE,

    CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_REQUEST,
    CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_SUCCESS,
    CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_FAILURE,
} from '../../types'

const initialState = {
    hasError: false,
    isLoading: false,
    errorMessage: '',
    errorCode: '',
    statusText: ''
}

export default (state = initialState, action) => {
    switch (action.type) {
        case CORE_LOAD_ORDERS_REQUEST:
        case CORE_LOAD_SLOTS_REQUEST:
        case CORE_LOAD_ROOMINFO_REQUEST:
        case CORE_LOAD_EVENTINCOMING_REQUEST:
        case LOAD_ROOMINFO_REQUEST:
        case CORE_LOAD_EVENTHISTORY_REQUEST:
        case CORE_LOAD_FLOORS_REQUEST:
        case CORE_CREATE_EVENT_REQUEST:
        case CORE_LOAD_AMENITIES_REQUEST:
        case BSRS_LOGIN_REQUEST:
        case CORE_LOAD_EVENTINFO_REQUEST:
        case CORE_EDIT_EVENT_REQUEST:
        case CORE_DELETE_EVENT_REQUEST:
        case CORE_CHECKIN_REQUEST:
        case CORE_LOAD_FLOOR_INFO_REQUEST:
        case CORE_LOAD_EVENTCALENDAR_REQUEST:
        case CORE_SEARCH_ROOMS_REQUEST:
        case CORE_LOAD_ROOMS_SUGGEST_REQUEST:
        case CORE_VERIFY_BYPASS_REQUEST:
        case CORE_LOAD_ROOM_FORMAT_REQUEST:
        case CORE_LOAD_SETTINGS_REQUEST:
        case CORE_SEND_EMAIL_REQ_RESET_PASSWORD_REQUEST:
        case CORE_CHANGE_PASSWORD_REQUEST:
        case CORE_FIRST_CHANGE_PASSWORD_REQUEST:
        case CORE_SEND_REPORT_REQUEST:
        case CORE_VERIFY_LOGIN_REQUEST:
        case CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_REQUEST:
            return {
                ...state,
                isLoading: true,
                hasError: false,
                errorMessage: '',
                errorCode: '',
                statusText: ''
            }
        case CORE_LOAD_ORDERS_SUCCESS:
        case CORE_LOAD_SLOTS_SUCCESS:
        case CORE_LOAD_ROOMINFO_SUCCESS:
        case LOAD_ROOMINFO_SUCCESS:
        case CORE_LOAD_EVENTINCOMING_SUCCESS:
        case CORE_LOAD_EVENTHISTORY_SUCCESS:
        case CORE_LOAD_FLOORS_SUCCESS:
        case CORE_CREATE_EVENT_SUCCESS:
        case CORE_LOAD_AMENITIES_SUCCESS:
        case BSRS_LOGIN_SUCCESS:
        case CORE_LOAD_EVENTINFO_SUCCESS:
        case CORE_EDIT_EVENT_SUCCESS:
        case CORE_DELETE_EVENT_SUCCESS:
        case CORE_CHECKIN_SUCCESS:
        case CORE_LOAD_FLOOR_INFO_SUCCESS:
        case CORE_LOAD_EVENTCALENDAR_SUCCESS:
        case CORE_SEARCH_ROOMS_SUCCESS:
        case CORE_LOAD_ROOMS_SUGGEST_SUCCESS:
        case CORE_VERIFY_BYPASS_SUCCESS:
        case CORE_LOAD_ROOM_FORMAT_SUCCESS:
        case CORE_LOAD_SETTINGS_SUCCESS:
        case CORE_SEND_EMAIL_REQ_RESET_PASSWORD_SUCCESS:
        case CORE_CHANGE_PASSWORD_SUCCESS:
        case CORE_FIRST_CHANGE_PASSWORD_SUCCESS:
        case CORE_SEND_REPORT_SUCCESS:
        case CORE_VERIFY_LOGIN_SUCCESS:
        case CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_SUCCESS:
            return {
                ...state,
                isLoading: false,
                hasError: false,
                errorMessage: '',
                errorCode: '',
                statusText: ''
            }
        case CORE_LOAD_ORDERS_FAILURE:
        case CORE_LOAD_FLOORS_FAILURE:
        case CORE_LOAD_ROOMINFO_FAILURE:
        case LOAD_ROOMINFO_FAILURE:
        case CORE_LOAD_SLOTS_FAILURE:
        case CORE_LOAD_EVENTINCOMING_FAILURE:
        case CORE_LOAD_EVENTHISTORY_FAILURE:
        case CORE_CREATE_EVENT_FAILURE:
        case CORE_LOAD_AMENITIES_FAILURE:
        case BSRS_LOGIN_FAILURE:
        case CORE_LOAD_EVENTINFO_FAILURE:
        case CORE_EDIT_EVENT_FAILURE:
        case CORE_DELETE_EVENT_FAILURE:
        case CORE_CHECKIN_FAILURE:
        case CORE_LOAD_FLOOR_INFO_FAILURE:
        case CORE_LOAD_EVENTCALENDAR_FAILURE:
        case CORE_SEARCH_ROOMS_FAILURE:
        case CORE_LOAD_ROOMS_SUGGEST_FAILURE:
        case CORE_VERIFY_BYPASS_FAILURE:
        case CORE_LOAD_ROOM_FORMAT_FAILURE:
        case CORE_LOAD_SETTINGS_FAILURE:
        case CORE_SEND_EMAIL_REQ_RESET_PASSWORD_FAILURE:
        case CORE_CHANGE_PASSWORD_FAILURE:
        case CORE_FIRST_CHANGE_PASSWORD_FAILURE:
        case CORE_SEND_REPORT_FAILURE:
        case CORE_VERIFY_LOGIN_FAILURE:
        case CORE_FIRST_CHANGE_PASSWORD__SEND_MAIL_FAILURE:
            let { statusText, code, message } = action.payload
            let returnData = {
                ...state,
                isLoading: false,
                hasError: true,
                statusText: statusText,
                errorCode: code,
                errorMessage: message
            }
            return returnData

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/features/ui/reducer.js